import apiClient from "./apiClient";

const tagsURL = "/tags";

export const createTag = async (formData) =>
  apiClient.post(`${tagsURL}/create`, formData).then((res) => res.data);

export const getAllTags = async () => {
  const response = await apiClient.get(`${tagsURL}/getall`);
  return response.data;
};

export const deleteTag = async (id) =>
  apiClient.delete(`${tagsURL}/${id}`).then((res) => res.data);
